// @ts-check
import { Component } from '@angular/core';
import { routerOutletStateTrigger } from '@animations/routerAnimations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [routerOutletStateTrigger],
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./src/app/components/main/app.component.ts